module.exports = __webpack_public_path__ + "static/media/twitter.eca9cb7c.svg";